export default __webpack_public_path__ + "static/media/rescue-bonus-ico.c448b69e.svg";